import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar } from '@material-ui/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Highlighter from 'react-highlight-words';
import * as actions from '~/store/actions';
import * as lib from '~/dependencies';
import { countryCodeAndFlagSelected } from '~/helpers/countryCodeAndFlagSelected';
import { Container, Row, Left, Right } from './styles';

const MIN_SEARCHABLE_STRING_LENGTH = 3;

export default function ContactList({
  setCountryCode,
  inputNumberHandler,
  withCall,
}) {
  const dispatch = useDispatch();

  const numberTo = useSelector(state => state?.system?.numberToTransfer);
  const contactsPersonal = useSelector(
    state => state.contact?.contactsPersonal ?? []
  );

  useEffect(() => {
    dispatch(actions.getContacts('All'));
    dispatch(actions.getContacts('Personal'));
  }, [dispatch]);

  function filtered(searchValue) {
    if (
      searchValue?.length > MIN_SEARCHABLE_STRING_LENGTH &&
      contactsPersonal?.length
    ) {
      const contactsPersonalFlatMap = contactsPersonal.flatMap(
        contact => contact.data
      );

      const filteredContacts = contactsPersonalFlatMap.filter(
        c =>
          c.mobile?.includes(searchValue.toUpperCase()) ||
          c.landline?.includes(searchValue.toUpperCase())
      );

      return filteredContacts;
    }
    return [];
  }

  function addNumber(number) {
    const valueNumber = String(number).trim();
    const { countryCallingCode, nationalNumber } = parsePhoneNumberFromString(
      valueNumber
    );

    const flagSelected = countryCodeAndFlagSelected(
      countryCallingCode,
      'callingCode'
    );
    if (flagSelected) {
      const { callingCode, code } = flagSelected;
      setCountryCode({
        callingCode,
        code,
      });
    }

    if (nationalNumber) {
      inputNumberHandler(nationalNumber);
      dispatch(actions.numberToTransfer(nationalNumber));
    }
  }

  const contactList = filtered(numberTo);

  return (
    <Container withCall={withCall}>
      {contactList.map(contact => {
        const landline = contact.landline
          ? parsePhoneNumberFromString(
              String(`+${contact.landline.slice(2)}`)
            )?.formatInternational()
          : null;

        const mobile = contact.mobile
          ? parsePhoneNumberFromString(
              String(`+${contact.mobile.slice(2)}`)
            )?.formatInternational()
          : null;

        return (
          <Row onClick={() => addNumber(landline || mobile)} key={contact?.id}>
            <Left>
              <Avatar className="avatar">{contact.name.slice(0, 2)}</Avatar>
              <span>{contact.name}</span>
            </Left>
            <Right>
              <span className="two-lines">
                {landline && (
                  <Highlighter
                    highlightClassName="highlight"
                    searchWords={[`${numberTo}`]}
                    autoEscape
                    textToHighlight={landline}
                  />
                )}
                {mobile && (
                  <Highlighter
                    highlightClassName="highlight"
                    searchWords={[`${numberTo}`]}
                    autoEscape
                    textToHighlight={mobile}
                  />
                )}
              </span>
            </Right>
          </Row>
        );
      })}
    </Container>
  );
}

ContactList.defaultProps = {
  setCountryCode: () => {},
  inputNumberHandler: () => {},
  withCall: false,
};

ContactList.propTypes = {
  setCountryCode: lib.PropTypes.func,
  inputNumberHandler: lib.PropTypes.func,
  withCall: lib.PropTypes.bool,
};
